// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3SoZl","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3CrUM"};